export default defineNuxtRouteMiddleware(async (to) => {
  devConsole.info("🛠️ ckAuth: middleware called", to.fullPath);

  const {
    $i18n: { t },
  } = useNuxtApp();
  const getRouteBaseName = useRouteBaseName();
  const notification = useGlobalNotification();
  const {
    autoLoginQueryParam,
    providerNameQueryParam,
    initQueryParams,
    makeQueryParams,
    goToUnauthorizedRedirectPage,
    goToRoot,
    createRedirectPath,
  } = useAuthQueryParams(to);
  const { authStore, initAuthApi, attemptLogin } = useAuthApi(to);

  if (to.query.ticketId?.length && getRouteBaseName(to) !== "redirecting") {
    devConsole.info("🛠️ ckAuth: ticketId found in query params, redirecting to transitioning page", to.query.ticketId);
    const ticketId = to.query.ticketId.toString();
    const warn = to.query.warn?.toString();
    const error = to.query.error?.toString();
    const redirect = new URL(to.fullPath, window.location.origin);
    redirect.searchParams.delete("ticketId");
    redirect.searchParams.delete("error");
    redirect.searchParams.delete("warn");

    return navigateTo(
      createRedirectPath({
        ticketId,
        redirect,
        error,
        warn,
      }),
    );
  }

  await initAuthApi();
  await initQueryParams();

  // if auto login on guest, attempt to login with provider
  if (!authStore.isAuthed && to.meta.allowAnonymous && autoLoginQueryParam.value) {
    const queryParams = makeQueryParams();
    await attemptLogin({
      loginHint: queryParams.loginHint,
      providerName: providerNameQueryParam.value,
    });
  }

  // If route needs user authenticated
  if (!authStore.isAuthed && !to.meta.allowAnonymous) {
    return goToUnauthorizedRedirectPage();
  }

  // show warning if the route allows anonymous access but the user is authenticated
  if (authStore.isAuthed && to.meta.allowAnonymous && to.meta.allowAnonymousWarningMessage) {
    notification.showWarning(t(to.meta.allowAnonymousWarningMessage));
  }

  // Strict anonymous access, only guest can access, if already authenticated, redirect to root page
  if (authStore.isAuthed && to.meta.allowAnonymous === "strict") {
    return goToRoot();
  }
});
